import { render, staticRenderFns } from "./CategoryButton.vue?vue&type=template&id=307777b6&scoped=true&"
import script from "./CategoryButton.vue?vue&type=script&lang=js&"
export * from "./CategoryButton.vue?vue&type=script&lang=js&"
import style0 from "./CategoryButton.vue?vue&type=style&index=0&id=307777b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307777b6",
  null
  
)

export default component.exports